import _ from 'lodash';

export default {
	commit,
	backup,
	get,
	restore,
	update,
	rollback,
};

let objs = [],
	stored = [],
	committed = false;

	function commit() {
	committed = true;
	// objs = []
	// stored = []
}
function backup(obj) {
	// in case save() crashes, i want to have backup available even after commit
	// until first call to backup() after commit() which will clear the cache
	if (committed) {
		stored = [];
		objs = [];
		committed = false;
	}
	// garder seulement la value primordiale, pas les successives
	// en cas de deplacement multiple d'une cat a l'autre, tres utile
	if (obj && objs.indexOf(obj) == -1) {
		objs.push(obj);
		stored.push(_.clone(obj));
	}
}
function get(obj) {
	var index = objs.indexOf(obj);
	return index != -1 && stored[index];
}
function restore(obj) {
	var index = objs.indexOf(obj);
	update(obj, stored[index]);
}
function update(obj, newObj) {
	if (_.isArray(obj)) {
		obj.splice(0, obj.length);
		obj.push.apply(obj, newObj);
	} else {
		_.extend(obj, newObj);
	}
}
function rollback() {
	for (var i in objs) {
		restore(objs[i]);
	}
	objs = [];
	stored = [];
	committed = false;
}
